(() => {
  const initBuddy = (root = document) => {
    root.querySelectorAll('[data-obp-buddy-main]').forEach((section) => {
      if (section.dataset.obpBuddyReady === 'true') return;
      section.dataset.obpBuddyReady = 'true';

      const mainImage = section.querySelector('[data-obp-buddy-main-image]');
      section.querySelectorAll('[data-obp-buddy-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage || !thumb.dataset.image) return;
          mainImage.src = thumb.dataset.image;
          mainImage.srcset = '';
          mainImage.alt = thumb.dataset.alt || '';
          section.querySelectorAll('[data-obp-buddy-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const buyButton = section.querySelector('[data-obp-buddy-buy-button]');
      const stickyCart = section.querySelector('[data-obp-buddy-sticky]');
      const stickySubmit = stickyCart?.querySelector('[data-obp-buddy-sticky-submit]');

      if (buyButton && stickyCart) {
        document.body.appendChild(stickyCart);

        const syncPreviewOffset = () => {
          stickyCart.classList.toggle(
            'is-shopify-preview',
            Boolean(document.getElementById('PBarNextFrame'))
          );
        };
        syncPreviewOffset();
        window.setTimeout(syncPreviewOffset, 500);

        const setStickyVisibility = (visible) => {
          stickyCart.classList.toggle('is-visible', visible);
          stickyCart.setAttribute('aria-hidden', visible ? 'false' : 'true');
          stickyCart.inert = !visible;
          document.body.classList.toggle('obp-buddy-sticky-visible', visible);
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => {
            setStickyVisibility(window.matchMedia('(max-width: 749px)').matches || (!entry.isIntersecting && entry.boundingClientRect.top < 0));
          }, { threshold: 0.05 });
          observer.observe(buyButton);
        } else {
          const updateSticky = () => {
            const rect = buyButton.getBoundingClientRect();
            setStickyVisibility(window.matchMedia('(max-width: 749px)').matches || rect.bottom < 0);
          };
          window.addEventListener('scroll', updateSticky, { passive: true });
          updateSticky();
        }

        stickySubmit?.addEventListener('click', () => {
          if (!buyButton.disabled) buyButton.click();
        });
      }
    });

    root.querySelectorAll('[data-obp-buddy-scroll-buy]').forEach((button) => {
      if (button.dataset.obpBuddyScrollReady === 'true') return;
      button.dataset.obpBuddyScrollReady = 'true';
      button.addEventListener('click', () => {
        const target = document.querySelector('#bestellen');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => {
          const buyButton = target.querySelector('[data-obp-buddy-buy-button]');
          if (buyButton) buyButton.focus({ preventScroll: true });
        }, 500);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBuddy());
  } else {
    initBuddy();
  }

  document.addEventListener('shopify:section:load', (event) => initBuddy(event.target));
})();
